import { render, staticRenderFns } from "./Quality.vue?vue&type=template&id=bd8cfbfe&scoped=true&"
var script = {}
import style0 from "./Quality.vue?vue&type=style&index=0&id=bd8cfbfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8cfbfe",
  null
  
)

export default component.exports